/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { FunctionComponent } from 'react';
import { fireOperationalAnalytics } from '@jira/platform__analytics-web-react/src/utils/fire-operational-event.tsx';
import type UIAnalyticsEvent from '@atlaskit/analytics-next/UIAnalyticsEvent';
import type { WithAnalyticsEventsProps } from '@atlaskit/analytics-next/withAnalyticsEvents';
import withInjectedProps from '@atlassian/jira-common-util-with-injected-props/src/index.tsx';
import { TenantContextSubscriber } from '@atlassian/jira-tenant-context-controller/src/components/tenant-context/index.tsx';
import BreadcrumbRenderer from './view.tsx';

const fireAnalytics = (analyticsEvent: UIAnalyticsEvent) =>
	fireOperationalAnalytics(analyticsEvent, { name: 'breadcrumbRendererMounted' });

const ExportedComponent: FunctionComponent<
	Omit<
		Omit<
			Omit<
				{
					TenantContextSubscriber: typeof TenantContextSubscriber;
					onMount: (args_0: UIAnalyticsEvent) => void;
				},
				keyof WithAnalyticsEventsProps
			>,
			keyof {
				TenantContextSubscriber: typeof TenantContextSubscriber;
				onMount: () => void;
			}
		> &
			Partial<
				Partial<
					Omit<
						{
							TenantContextSubscriber: typeof TenantContextSubscriber;
							onMount: (args_0: UIAnalyticsEvent) => void;
						},
						keyof WithAnalyticsEventsProps
					>
				>
			>,
		'onMount' | 'TenantContextSubscriber'
	>
> = withInjectedProps(BreadcrumbRenderer, {
	onMount: fireAnalytics,
	TenantContextSubscriber,
});
export default ExportedComponent;
